/**
 * Get Reader Poll
 * @param {string} storyId
 * @param {string} partId
 * @returns {poll: object} - Returns the reader poll object
 */

const clientAPICall = url => {
    return Promise.resolve(
      $.ajax({
        type: "GET",
        url: url,
        xhrFields: {
          withCredentials: true
        },
      })
    );
  };
  
  module.exports = function(storyId, partId) {
    return new Promise(async function(resolve, reject) {
      const url = `${wattpad?.apiDomain}/reading/v1/stories/${storyId}/parts/${partId}/polls`;
  
      await clientAPICall(url)
        .then(poll => {
          return resolve(poll);
        })
        .catch(err => {
          return reject(err);
        });
    });
  };